import OrderAction from './orderAction';
import Attendee from '../../../models/attendeeModel';
import Order from '../models/orderModel';
import RestoreActionAttendee from '../../../pages/attendee/actions/restoreAction';

export default class RestoreAction extends OrderAction {
    static NAME = 'restore';
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    //only reserved and payed with with at least one deleted participant
    static condition(order) {
        return ['valid', 'reservation'].includes(order.status) && order.attendees_deleted_count > 0;
    }

    static is_attendee_valid({ attendee, order }) {
        return RestoreActionAttendee.is_attendee_valid({ attendee, order });
    }

    //available if event no closed, no over, no deleted and without seating
    static is_available({ feature_flags, event }) {
        return !event.isRealSeating() && !event.isFakeSeating() && !event.use_sessions && !['over', 'closed'].includes(event.status) && !event.removed;
    }

    run({ orders = null, attendees = null }) {
        if (attendees) {
            //only deleted and without seat
            const to_restore = attendees.filter(a => a.removed && !a.booking);
            return Attendee.perform_action(RestoreActionAttendee.NAME, to_restore, { organization: this.organization, event: this.event });
        }

        return Order.perform_action(this.constructor.NAME, orders || this.filtered_items, { organization: this.organization, event: this.event }, this.isAsync(orders));
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }
}
